import React, { useState } from 'react'
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { useSelector } from 'react-redux'; 

const TableComponentReport = ({report, meters,parameter}) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
    // console.log(report)
    console.log(meters)

    const columns = [];
    
      meters.map((i)=>{
            columns.push({field:i.dataIndex,width:i.minWidth, flex: 1})
      })
      console.log(columns)
  const color = useSelector((state) => state.ThemeChange);
    console.log(color)

  return (
    <div
          className={`${isdarkMode ? "ag-theme-quartz-dark": "ag-theme-alpine"}`}
          style={{
            '--ag-header-background-color': color.themeConfig.colorPrimary, 
            '--ag-header-foreground-color': '#fff', 
            height: "80vh", width: "100%", overflowY: "auto" 
          }}
        >
          <AgGridReact
            rowData={report}
            columnDefs={columns.length>1 ?columns :[]}
            defaultColDef={{
              resizable: true, 
            }}
            pagination={true}
            domLayout="normal" 
            rowHeight={50}
            suppressHorizontalScroll={false} 
          />
        </div>
  )
}

export default TableComponentReport